module.exports = __webpack_public_path__ + "static/en-logo100-web-black-483cc84b2f0f78baa34ec3eafca46e59.svg";